export default __webpack_public_path__ + "static/media/logo-dark.ff195469.svg";